module.exports = __webpack_public_path__ + "static/media/fleche-droit.c1368302.svg";